import { useParams } from "react-router-dom";
import { useState } from "react";
import { usePeriodicLoadData } from "../hooks/usePeriodicLoadData";
import { useMutation } from "@tanstack/react-query";
import { useAuth } from "../lib/AuthContext";
import { useData } from "../lib/DataContext";
import config from "../config";
import useBrandTranslation from "../hooks/useBrandTranslation";
import tr from "../i18n/translate";

const BASE_URL = "/api/mercadopago";

export const useCreateMPPreferenceMutation = async (body) => {
  const res = await fetch(`${BASE_URL}/preferences`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    throw new Error(tr("app.payments.mpRequestError", "Error en la petición"));
  }
  return res.json();
};

export default function Payments() {
  const { t } = useBrandTranslation();
  const { appointmentId } = useParams();

  const { user } = useAuth();
  const { schedules, appointments, addAppointment, sharedSchedules, loadData } =
    useData();

  usePeriodicLoadData(loadData, undefined, !!appointmentId && !!user?.id);

  const selectedAppointment = appointments.find(
    (appointment) => appointment.id === appointmentId
  );

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const createMutation = useMutation({
    mutationFn: useCreateMPPreferenceMutation,
    onSuccess: (data) => {
      console.log("Preference creada:", data);
    },
    onError: (error) => {
      console.error("Error creando preference:", error);
    },
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await createMutation.mutateAsync({
        title: "Turno reservado en " + config.brand,
        price: Number.parseFloat(selectedAppointment.price),
        quantity: 1,
        appointmentId,
      });

      console.log(response);
      debugger;
      if (response.url) {
        window.location.href = response.url;
      } else {
        throw new Error(t("app.payments.mpPaymentUrlError", "No se pudo obtener la URL de pago"));
      }
    } catch (err) {
      console.error("Error al crear preferencia de pago:", err);
      setError(
        t("app.payments.mpProcessError", "Ocurrió un error al procesar el pago. Por favor intenta nuevamente.")
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="px-4 h-full overflow-auto mt-0 flex flex-col items-center justify-center">
      <div className="p-6 pb-4">
        <div className="max-w-3xl mx-auto p-4">
          <h1 className="text-2xl font-bold mb-4">{t("app.payments.title", "Detalles del pago")}</h1>
          <p className="text-gray-700 mb-4">
            Aquí puedes gestionar tus pagos y ver el estado de tus
            transacciones.
          </p>
          {/* <p className="text-gray-700 mb-4">
            {appointmentId
              ? `ID de la cita: ${appointmentId}`
              : "No se ha proporcionado un ID de cita."}
          </p> */}
          {/* Aquí puedes agregar más contenido relacionado con los pagos */}
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="px-6 pb-6">
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-500 hover:bg-blue-600 disabled:bg-blue-400 disabled:cursor-not-allowed text-white font-medium py-2 px-4 rounded-md transition-colors duration-200 flex items-center justify-center"
          >
            {loading ? (
              <>
                <svg
                  className="animate-spin -ml-1 mr-3 h-4 w-4 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Procesando...
              </>
            ) : (
              t("app.payments.payWithMp", "Pagar con MercadoPago")
            )}
          </button>
        </div>
      </form>
    </div>
  );
}
